

// Filter button -> triggers Dawn's native drawer summary
document.addEventListener('click', (event) => {
  const filterBtn = event.target.closest('#MobileFilterTrigger');
  if (!filterBtn) return;
  const summary = document.querySelector('.mobile-facets__wrapper summary.mobile-facets__open-wrapper');
  if (summary) summary.click();
});

// Grid view toggle (1 vs 2 columns on mobile)
document.addEventListener('click', (event) => {
  const btn = event.target.closest('.mobile-toolbar__view-btn');
  if (!btn) return;
  const columns = btn.getAttribute('data-columns');
  const grid = document.getElementById('product-grid');
  if (!grid) return;

  grid.classList.remove('grid--1-col-tablet-down', 'grid--2-col-tablet-down');
  grid.classList.add(`grid--${columns}-col-tablet-down`);

  document.querySelectorAll('.mobile-toolbar__view-btn').forEach((b) => b.classList.remove('is-active'));
  btn.classList.add('is-active');
});

// Sort modal
class SortModal extends HTMLElement {
  constructor() {
    super();
    document.body.appendChild(this);

    document.addEventListener('click', (event) => {
      if (event.target.closest('#MobileSortTrigger')) this.open();
      if (event.target.closest('[data-sort-close]') || event.target.closest('.sort-modal__backdrop')) this.close();
    });

    this.querySelectorAll('.sort-modal__option').forEach((option) => {
      option.addEventListener('click', () => this.selectOption(option));
    });
  }

  open() {
    this.classList.add('is-open');
    document.body.style.overflow = 'hidden';
  }

  close() {
    this.classList.remove('is-open');
    document.body.style.overflow = '';
  }

  selectOption(option) {
    const value = option.getAttribute('data-value');
    // Always fetch the LIVE select element, not a stale cached reference
    const select = document.getElementById('SortBy-mobile');
    if (!select) return;

    select.value = value;
    select.dispatchEvent(new Event('input', { bubbles: true }));
    select.dispatchEvent(new Event('change', { bubbles: true }));

    this.querySelectorAll('.sort-modal__option').forEach((el) => el.classList.remove('is-selected'));
    option.classList.add('is-selected');

    this.close();
  }
}

customElements.define('sort-modal', SortModal);